import { render, staticRenderFns } from "./LaboratoryPromocodesSearchPanel.vue?vue&type=template&id=5ca5ba0a&scoped=true"
import script from "./LaboratoryPromocodesSearchPanel.vue?vue&type=script&lang=js"
export * from "./LaboratoryPromocodesSearchPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5ba0a",
  null
  
)

export default component.exports